import FormattedMessage from 'I18n/components/FormattedMessage';
import isValidI18nKey from 'I18n/utils/isValidI18nKey';
import { TIME_SERIES } from 'reporting-data/constants/configTypes';
import { H5 } from 'foundations-components/transitional/components/H5';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const getFrequency = config => config.getIn(['frequency']);
const isTimeSeriesReport = config => config.getIn(['configType']) === TIME_SERIES;
export const shouldReportShowInlineFrequencyLabel = config => !!getFrequency(config) && isTimeSeriesReport(config) && isValidI18nKey(`settingLabels.frequency.valueLabels.${getFrequency(config)}`);
export const ReportFrequencyTooltipContent = ({
  config
}) => {
  return /*#__PURE__*/_jsxs(View, {
    "data-test-id": "report-frequency-tooltip",
    marginBlockStart: "500",
    as: "div",
    children: [/*#__PURE__*/_jsx(H5, {
      marginBlockEnd: "100",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "settingLabels.frequency.inlineLabel"
      })
    }), /*#__PURE__*/_jsx(FormattedMessage, {
      message: `settingLabels.frequency.valueLabels.${getFrequency(config)}`
    })]
  });
};